import React, { createContext, useState, useEffect } from "react";

export const AuthContext = createContext();

const AuthProvider = ({ children }) => {
  const [userId, setUserId] = useState(() => localStorage.getItem("user_id"));
  const [sessionId, setSessionId] = useState(() =>
    localStorage.getItem("session_token"),
  );
  const [isGuest, setIsGuest] = useState(
    () => localStorage.getItem("isGuest") === "true",
  );

  /* =====================
     PERSIST STORAGE
  ===================== */
  useEffect(() => {
    userId
      ? localStorage.setItem("user_id", userId)
      : localStorage.removeItem("user_id");
  }, [userId]);

  useEffect(() => {
    sessionId
      ? localStorage.setItem("session_token", sessionId)
      : localStorage.removeItem("session_token");
  }, [sessionId]);

  useEffect(() => {
    localStorage.setItem("isGuest", isGuest);
  }, [isGuest]);

  /* =====================
     AUTH FUNCTIONS
  ===================== */
  const login = (id, session) => {
    setUserId(id);
    setSessionId(session);
    setIsGuest(false);
  };

  const guestLogin = () => {
    setUserId(null);
    setSessionId(null);
    setIsGuest(true);
  };

  const logout = () => {
    console.log("🚪 Logging out...");

    // ✅ Clear browser storage
    localStorage.clear();

    setUserId(null);
    setSessionId(null);
    setIsGuest(false);

    // ✅ 🔥 INFORM REACT NATIVE APP
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage("");
    }

    console.log("✅ Logout complete");
  };

  return (
    <AuthContext.Provider
      value={{ userId, sessionId, isGuest, login, guestLogin, logout }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export default AuthProvider;
